import { DataQueryParams } from 'common/src/query-params/DataQueryParams';
import { IPage, IStatement } from 'common/src/types/interfaces';

import { API_BASE_PATHS, formContentType } from 'portal/src/api/constants';
import formatQueryParams from 'portal/src/api/formatQueryParams';
import {
  getBlobRequest,
  getRequest,
  patchRequest,
  postRequest,
} from 'portal/src/api/requestTypes';

export const getStatements = async (
  params?: DataQueryParams,
): Promise<IPage<IStatement>> =>
  await getRequest(API_BASE_PATHS.STATEMENTS, formatQueryParams(params));

export const getStatementImage = (annotated: boolean) => async (id: string) =>
  await getBlobRequest(
    `${API_BASE_PATHS.STATEMENTS}/${id}/image?annotated=${annotated}`,
  );

export const uploadStatementFiles = async (files: {
  files: File[];
}): Promise<string[]> =>
  await postRequest(
    `${API_BASE_PATHS.STATEMENTS}/upload`,
    {},
    files,
    formContentType,
  );

export const ignoreStatement = async (
  id: string,
  reason: string,
): Promise<void> =>
  await patchRequest(
    `${API_BASE_PATHS.STATEMENTS}/${id}/ignore`,
    {},
    { reason },
  );
